import React from 'react';
import PropTypes from 'prop-types';

const EventsCountCell = ({ totalEvents, upcomingCount, pastCount }) => (
  <span className="series-events-count-cell">
    <span className="series-events-count-total">{totalEvents}</span>
    {' events · '}
    {upcomingCount} upcoming · {pastCount} past
  </span>
);

EventsCountCell.propTypes = {
  totalEvents: PropTypes.number.isRequired,
  upcomingCount: PropTypes.number.isRequired,
  pastCount: PropTypes.number.isRequired,
};

export default EventsCountCell;
